import React, { Fragment, useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import { lastPage, saveLastPage } from "../utils/helper";
import { useTranslation } from "react-i18next";

export default function CustomPagination({ paginationData, size, nextPage, component, initCall = true, jumpPage, count = true }) {
    const { t, i18n } = useTranslation();
    const [goToPage, setGoToPage] = useState();
    const [globalConfig, setGlobalConfig] = useState({
        maxButtonShow: 10
    });

    const getPageNumbers = () => {
        const totalPages = paginationData?.totalPages;
        const currentPage = paginationData?.number; // assuming 0-based index
        const maxButtons = globalConfig.maxButtonShow; // showing buttons

        let start = Math.max(0, currentPage - Math.floor(maxButtons / 2));
        let end = start + maxButtons;

        if (end > totalPages) {
            end = totalPages;
            start = Math.max(0, end - maxButtons);
        }

        return Array.from({ length: end - start }, (_, i) => start + i);
    };

    const jumpToPage = () => {
        if (
            goToPage &&
            goToPage <= paginationData?.totalPages &&
            goToPage != paginationData?.number + 1
        ) {
            nextPage(goToPage - 1)
        } else {
            if (goToPage == (paginationData?.number + 1)) {
                alert(`You are already on page ${paginationData.number + 1}`);
            } else {
                alert(`invalid page number (${goToPage}) !!! available pages (1 - ${paginationData?.totalPages})`);
            }
        }
    }

    useEffect(() => saveLastPage(component, paginationData), [paginationData]);

    useEffect(() => { if (initCall) nextPage(lastPage(component)) }, []);


    return (
        <React.Fragment>
            {/* Pagination Start */}
            {
                Object.keys(paginationData).length > 0 ?
                    <div className="pagination-scroll">
                        <Pagination size={size}>
                            {paginationData &&
                                paginationData?.first !== true ?
                                <Fragment>
                                    <Pagination.First onClick={(e) => nextPage(0)} />
                                    <Pagination.Prev onClick={(e) => nextPage(paginationData?.number - 1)} />
                                    {
                                        (paginationData?.number + 1) > Math.ceil(globalConfig?.maxButtonShow / 2)
                                            && paginationData?.totalPages > Math.ceil(globalConfig?.maxButtonShow)
                                            ?
                                            <Pagination.Ellipsis />
                                            : ""
                                    }
                                </Fragment>
                                : ""
                            }
                            {paginationData && paginationData?.totalPages > 0 &&
                                getPageNumbers().map((page) => (
                                    <Pagination.Item
                                        key={page}
                                        active={page === paginationData?.number}
                                        onClick={() => nextPage(page)}>
                                        {page + 1}
                                    </Pagination.Item>
                                ))
                            }
                            {paginationData &&
                                paginationData?.last === false ?
                                <Fragment>
                                    {
                                        Math.abs(((paginationData?.number + 1) - paginationData?.totalPages)) > Math.abs((Math.ceil(globalConfig?.maxButtonShow) - 1))
                                            // && paginationData?.totalPages < Math.ceil(globalConfig?.maxButtonShow)
                                            ?
                                            <Pagination.Ellipsis />
                                            : ""
                                    }
                                    <Pagination.Next onClick={(e) => nextPage(paginationData?.number + 1)} />
                                    <Pagination.Last onClick={(e) => nextPage(paginationData?.totalPages - 1)} />
                                </Fragment>
                                : ""
                            }
                            {paginationData &&
                                <Fragment>
                                    {
                                        jumpPage && paginationData.totalPages > 1 ?
                                            <Pagination.Item className="">
                                                <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                                                    <span style={{ fontSize: "12px" }}>{t("Page")} </span>

                                                    <input
                                                        type="number"
                                                        min="1"
                                                        // max={paginationData?.totalPages}
                                                        value={goToPage}
                                                        onChange={(e) => setGoToPage(Number(e.target.value))}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                jumpToPage();
                                                            }
                                                        }}
                                                        style={{
                                                            width: "50px",
                                                            height: "22px",
                                                            fontSize: "12px",
                                                            padding: "2px 4px",
                                                            borderRadius: "4px",
                                                            border: "1px solid #ccc",
                                                        }} />

                                                    <button
                                                        onClick={(e) => {
                                                            jumpToPage();
                                                        }}
                                                        style={{
                                                            height: "20px",
                                                            fontSize: "12px",
                                                            borderRadius: "4px",
                                                            background: "#007bff",
                                                            color: "white",
                                                            border: "none",
                                                            cursor: "pointer",
                                                        }}>
                                                        Go
                                                    </button>
                                                </div>
                                            </Pagination.Item>
                                            : ""
                                    }

                                    {
                                        count && paginationData?.totalElements > 0 ?
                                            <>
                                                <Pagination.Item >{t("Table Count")} : {paginationData?.numberOfElements}</Pagination.Item>
                                                <Pagination.Item >{t("Pages")} : {paginationData?.totalPages}</Pagination.Item>
                                                <Pagination.Item >{t("Total Count")} : {paginationData?.totalElements}</Pagination.Item>
                                            </>
                                            : ""
                                    }
                                    {/* <Pagination.Item >{t("Table Count")} : {paginationData?.numberOfElements}</Pagination.Item>
                            <Pagination.Item >{t("Pages")} : {paginationData?.totalPages}</Pagination.Item>
                            <Pagination.Item >{t("Total Count")} : {paginationData?.totalElements}</Pagination.Item> */}

                                </Fragment>
                            }
                        </Pagination>

                    </div>
                    : ""
            }
            {/* Pagination End */}
        </React.Fragment >
    );
}